import React from "react";
import Table from "react-bootstrap/Table";
import { Card, CardHeader, Row, Col, CardBody, Button, FormSelect, FormInput } from "shards-react";
import { Link } from "react-router-dom";
import { TiEdit, TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import { FcPlus, FcDownload } from "react-icons/fc";
import ConversionDataService from "../../services/conversions.service";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { actions as AppActions } from "../../_stores/app.store";
import CustomPagination from "../common/CustomPagination";
import * as XLSX from "xlsx";
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import authStore from "../../_stores/auth.store";

const perPage = 10;
const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

const Columns = [
  {
    title: "Retailer ID",
    value: "RetailerId",
  },
  {
    title: "PRODUCT CODE",
    value: "PROD_CODE",
  },
  {
    title: "PRODUCT NAME",
    value: "PROD_NAME",
  },
  {
    title: "COMPANY NAME",
    value: "COMP_NAME",
  },
  {
    title: "UOM",
    value: "UOM",
  },
  {
    title: "Conversion",
    value: "Conversion",
  },
];

class ViewConversions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      conversionsList: [],
      conversionsList_paged: [],
      filteredColumn: "",
      filteredColumnValue: "",
    };
    this.aggridRef = React.createRef();
    this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
    this.exportConversionsToExcel = this.exportConversionsToExcel.bind(this);
    this.filterReport = this.filterReport.bind(this);
    this.onChangeFilteredColumnValue = this.onChangeFilteredColumnValue.bind(this);
  }

  componentDidMount() {
    this.retrieveConversions();
  }

  componentDidUpdate(prevProps) {}

  retrieveConversions() {
    AppActions.setLoading(true);
    ConversionDataService.getAll().then((response) => {
      //console.log(response.data.data);
      AppActions.setLoading(false);
      this.setState({
        conversionsList: response.data.data,
      });
    });
  }

  deleteConversion(id) {
    AppActions.setLoading(true);
    ConversionDataService.delete(id).then((response) => {
      this.retrieveConversions();
      this.props.notify("success", "Conversion Deleted");
    })
    .catch((error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      this.setState({
        message: message,
      });
      this.props.notify("error", message);
      AppActions.setLoading(false);
    });
  }

  exportConversionsToExcel(type) {
    const { conversionsList } = this.state;
    const sheetdata = [];
    let filterList = conversionsList;
    console.log('filterList', filterList);
    console.log('type', type);
    if(type === 0) {
      filterList = filterList.filter((item) => item.isConversionFound === '0');
    }
    sheetdata.push(["id", "Retailer ID", "Product Code", "Product Name", "Company Name", "UOM", "Conversion", "Conversion Found"]);
    for (let i = 0; i < filterList.length; i++) {
      const conItem = filterList[i];
      sheetdata.push([conItem.id, conItem.RetailerId, conItem.PROD_CODE, conItem.PROD_NAME, conItem.COMP_NAME, conItem.UOM, conItem.Conversion, conItem.isConversionFound]);
    }
    this.prepWorkbookFromJson(sheetdata);
  }

  prepWorkbookFromJson(sheetdata) {
    const worksheet = XLSX.utils.json_to_sheet(sheetdata, {
      skipHeader: true,
    });
    const wsColWidths = sheetdata[0].map((th) => ({ wch: th.length + 1 }));
    worksheet["!cols"] = wsColWidths;
    const workbook = {
      Sheets: { ["Sheet1"]: worksheet },
      SheetNames: ["Sheet1"],
    };
    const excelBuffer = XLSX.write(workbook, {
      type: "buffer",
      bookType: "xlsx",
    });
    this.createUrlFromBlob(excelBuffer);
  }

  createUrlFromBlob(bufferData) {
    const blob = new Blob([bufferData], { type: EXCEL_TYPE });
    const objurl = URL.createObjectURL(blob);
    this.downloadFile(objurl, "conversion_factor_master_" + new Date().getTime() + EXCEL_EXTENSION);
    URL.revokeObjectURL(objurl);
  }

  downloadFile(objurl, filename) {
    const anchor = document.createElement("a");
    anchor.href = objurl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  }

  onPageSizeChanged(e) {
    let value = e.target.value;
    this.aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  onChangeFilteredColumnValue(e){
    this.setState({ filteredColumnValue: e.target.value});
  }

  filterReport() {
    console.log('filterReport');
    const { filteredColumn, filteredColumnValue } = this.state;
    AppActions.setLoading(true);
    ConversionDataService.getByCondition(filteredColumn, filteredColumnValue).then((response) => {
      //console.log(response.data.data);
      AppActions.setLoading(false);
      this.setState({
        conversionsList: response.data.data,
      });
    });
  }

  render() {
    const { conversionsList, conversionsList_paged, filteredColumn, filteredColumnValue } = this.state;
    const isDisabled = ((filteredColumn === '' || filteredColumn === 0 || filteredColumn === null) 
          || (filteredColumnValue === '' || filteredColumnValue === null || filteredColumnValue === 0 ));
    const columnDefs = [
      {headerName: "ID", field: "id", filter: true, sortable:true, unSortIcon:true, width:"100", },
      {headerName: "Retailer ID", field: "RetailerId", filter: true, sortable:true, unSortIcon:true },
      {headerName: "Product Code", field: "PROD_CODE",filter: true, sortable:true, unSortIcon:true},
      {headerName: "Product Name", field: "PROD_NAME",filter: true, sortable:true, unSortIcon:true},
      {headerName: "Company Name", field: "COMP_NAME",filter: true, sortable:true, unSortIcon:true},
      {headerName: "UOM", field: "UOM",filter: true, sortable:true, unSortIcon:true},
      {headerName: "Conversion", field: "Conversion",filter: true, sortable:true, unSortIcon:true},
      {headerName: "Conversion Found", field: "isConversionFound",filter: true,  sortable:true, width:"160",
          cellRendererFramework: (data) => {
            return data.value === '1' ? 'YES' : 'NO'
          } 
      },
      {headerName: "Updated At", field: "updatedDate",filter: true,  sortable:true, width:"160",
          cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "action", field:"id", 
        cellRendererFramework: (data) => {
          return <>
            <Link title="Details" className="text-primary mr-2" to={"/conversion/"+data.value+"/details"}><TiEyeOutline  size="20" /></Link>
            <Link title="Edit" className="text-success mr-2" to={"/conversion/"+data.value+"/edit"}><TiEdit  size="20" /></Link>
            {authStore.getState().auth_reducer.user.role === "superadmin" && (
              <span className="text-danger cursor-pointer" title="delete" onClick={() => this.deleteConversion(data.value)}><TiDeleteOutline size="20" /></span>
            )}
          </>
        }
      }
    ]
    return (
      <>
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0">
                  Conversions List
                  <Link className="btn btn-primary ml-4" to={"/conversion/create"}>
                    <FcPlus /> Create New Conversion
                  </Link>
                  <Button variant="primary" className="ml-3 btn btn-success" onClick={() => this.exportConversionsToExcel(1)}>
                    <FcDownload /> Export Table Conversion Data
                  </Button>
                  <Button variant="primary" className="ml-3 btn btn-success" onClick={() => this.exportConversionsToExcel(0)}>
                    <FcDownload /> Export New Conversion Data
                  </Button>
                </h6>
              </CardHeader>

              <CardHeader className="border-bottom row no-gutters removemargin">

              <Col md="12" className="mt-3 removemargin">
                  <Row className="form-group">
                    <Col className="form-field"  md="4">
                      <label className="mb-0">Filter</label>
                        <FormSelect
                          className="form-field"
                          id="column-filter"
                          onChange={(evt) => this.setState({ filteredColumn: evt.target.value })}
                          value={filteredColumn}
                        >
                          <option value={0}>Select</option>
                          {Columns.map((column) => (
                            <option key={column.value} value={column.value}>
                              {column.title}
                            </option>
                          ))}
                        </FormSelect>
                    </Col>
                    <Col className="form-field" md="4">
                      <label className="mb-0">Filter Value</label>
                        <FormInput
                          className="form-field"
                          id="column-filter-value"
                          placeholder="Filter Value"
                          value={filteredColumnValue}
                          onChange={this.onChangeFilteredColumnValue}
                        />
                    </Col>
                    <Col className="form-field" md="2">
                      <Button variant="primary" disabled={isDisabled} className="mt-4 btn btn-success" onClick={this.filterReport}>
                        Filter
                      </Button>
                    </Col>
                  </Row>
                </Col>
                 
              </CardHeader>
              <CardBody className="p-0 pb-3">
                <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
                  <div className="example-header">
                    Page Size: &nbsp;
                    <select onChange={this.onPageSizeChanged} id="page-size">
                      <option value="10" selected={true}>
                        10
                      </option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                  <AgGridReact
                      ref={this.aggridRef}
                      pagination={true}
                      rowHeight={50}
                      paginationPageSize={perPage}
                      columnDefs={columnDefs}
                      rowData={conversionsList}
                  >
                  </AgGridReact>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default ViewConversions;
